<div id="info-bar" class="mb-0 mb-sm-5 ">
  <div class="info-bar-header">
    {{productName}}
  </div>
  <div class="info-bar-body">
    <div class="row mx-0 align-items-start">
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <div class="info-bar-title">{{ 'Buyer.HostedBy' | translate }}</div>
        <div class="info-bar-value">
          <a target="_blank" routerLink="/{{bussinessName}}">
            <div class="text-white">{{bussinessName}}</div>
          </a>
        </div>
        <div class="info-bar-title mt-2">{{ 'Buyer.Location' | translate }}</div>
        <div class="info-bar-value">{{location}}</div>
        <div class="col-lg-10 px-0 d-flex">
          <button class="btn btn-primary col-12 my-auto ml-auto" type="submit" (click)="openMap()">
            {{'See_Location' | translate}}
          </button>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
        <div class="info-bar-title">{{ 'Buyer.StartsAt' | translate }}</div>
        <div class="info-bar-value">{{startDay |date:'mediumDate'}}</div>
        <div class="info-bar-title mt-2">{{ 'Buyer.EndsAt' | translate }}</div>
        <div class="info-bar-value">{{endDay|date:'mediumDate'}}</div>
      </div>
    </div>
  </div>
</div>
